import { render, staticRenderFns } from "./NotificationTypeIcons.vue?vue&type=template&id=622353fa"
import script from "./NotificationTypeIcons.vue?vue&type=script&lang=ts"
export * from "./NotificationTypeIcons.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTypeIcons.vue?vue&type=style&index=0&id=622353fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItemIcon})
